import { getStorage } from "./storage";
class ConsentManager {
    updateGtagConsent() {
        const gtag = window.gtag;
        if (typeof gtag !== 'function') {
            return;
        }
        gtag('consent', 'update', this.getConsentForGtag());
        // Sending a custom event to GTM that can be handled there (optionally)
        const dataLayer = window.dataLayer || [];
        dataLayer.push({ 'event': 'cookie_consent_update' });
    }
    getConsentForGtag() {
        const hasNecessaryConsent = true;
        const hasTargetingConsent = getStorage('targeting_cookies') == '1';
        const hasTrackingConsent = getStorage('stats_cookies') == '1';
        const hasFunctionalityConsent = getStorage('wcag_cookies') == '1';
        return {
            'analytics_storage': hasTrackingConsent ? 'granted' : 'denied',
            'ad_storage': hasTargetingConsent ? 'granted' : 'denied',
            'ad_user_data': hasTargetingConsent ? 'granted' : 'denied',
            'ad_personalization': hasTargetingConsent ? 'granted' : 'denied',
            'functionality_storage': hasFunctionalityConsent ? 'granted' : 'denied',
            'security_storage': hasNecessaryConsent ? 'granted' : 'denied',
            'personalization_storage': hasFunctionalityConsent ? 'granted' : 'denied',
        };
    }
}
const consentManager = new ConsentManager();
export default consentManager;
